import { MenuItem, TextField } from '@mui/material';
import { useController } from 'react-hook-form';

type RevisionsSelectFieldProps = {
    name: string;
    label: string;
    rules?: Object;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
};

const options = [
    '101 - Price Sensitivity Concern',
    '102 - New Product',
    '103 - Inventory Positioning',
    '104 - Revise Primary Competitor',
    '105 - Reseller Competition',
    '106 - Wholesale Conflict',
    '107 - Forecasted Category Changes',
    '108 - Price Laddering',
    '109 - Seasonal',
    '110 - Market Prices Have Not Moved Up',
    '199 - Other',
];
export default function RevisionSelect({ name, rules, label, disabled, error, helperText }: RevisionsSelectFieldProps) {
    const {
        field: { value, onChange, onBlur },
    } = useController({
        name,
        rules,
    });
    return (
        <TextField
            label={label}
            disabled={disabled}
            select
            value={value || ''}
            fullWidth
            error={error}
            helperText={helperText}
            onChange={onChange}
            onBlur={onBlur}
        >
            <MenuItem value=''>No Reason</MenuItem>
            {options.map((option, i) => (
                <MenuItem value={option} key={i}>
                    {option}
                </MenuItem>
            ))}
        </TextField>
    );
}
